import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../models/error.model';
import { IMainApiService } from '../../../../../services/api.service';
import { IApiService } from '../../../../../services/api.service.base';
import { IRejectionReason } from '../models/rejectionReason';

export class GetRejectionReasonRequest {
  projectId: string;

  constructor(projectId: string) {
    this.projectId = projectId;
  }
}

export namespace IRejectionReasonService {
  export const $: interfaces.ServiceIdentifier<IRejectionReasonService> = Symbol('REJECTION_REASON_SERVICE');
}

export interface IRejectionReasonService {
  getRejectionReasons(request: GetRejectionReasonRequest): Promise<IRejectionReason[] | ACDLError>;
}

@injectable()
export class RejectionReasonService implements IRejectionReasonService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  async getRejectionReasons(request: GetRejectionReasonRequest): Promise<IRejectionReason[] | ACDLError> {
    return await this.apiService.getAsync<IRejectionReason[]>('/annotation/RejectionReasons', { params: request });
  }
}
